import * as Yup from "yup";

export const getNewRecipeBasicDataSchema = (t) => Yup.object().shape({
  name: Yup.string().required(t('page.recipe.add.form.validation.name_required')),
  mealTypes: Yup.array()
    .nullable()
    .required(t('page.recipe.add.form.validation.meal_type_required'))
    .min(1, t('page.recipe.add.form.validation.meal_type_min')),
  for_how_many_person: Yup.string().required(t('page.recipe.add.form.validation.for_how_many_person_required')),
  time_consuming: Yup.string().required(t('page.recipe.add.form.validation.time_consuming_required')),
});

export const getNewRecipeFinalDataSchema = (t) => Yup.object().shape({
  description: Yup.string(),
  image: Yup.object().nullable().required(t('page.recipe.add.form.validation.main_image_required')),
});

export const getNewRecipeIngredientDataSchema = (t) => Yup.object().shape({
  ingredients: Yup.array()
    .of(
      Yup.object().shape({
        selected: Yup.object().nullable().required(t('page.recipe.add.form.validation.ingredient_name_required')),
        quantity: Yup.string().required(t('page.recipe.add.form.validation.quantity_required'))
      })
    )
    .min(1, t('page.recipe.add.form.validation.ingredient_min')),
});

export const getNewRecipePreparationDataSchema =  (t) => Yup.object().shape({
  steps: Yup.array()
    .of(
      Yup.object().shape({
        description: Yup.string()
          .transform(input => input.replace(/<\/?[^>]+(>|$)/g, ""))
          .required(t('page.recipe.add.form.validation.preparation_step_required'))
      })
    )
    .min(1, t('page.recipe.add.form.validation.preparation_step_min')),
});
